import { useGenericQuery } from '../../../core/api/reactQuery';
import { getPracticeFeedback } from '../queries';
import { practiceFinishedStore } from '../stores/practiceFinishedStore';

export function useGetPracticeFeedback(id: string) {
  const { setPractice } = practiceFinishedStore()
  const {
    data,
    isError,
    error,
    isSuccess,
    isPending
  } = useGenericQuery(['practiceFinished', id], () => getPracticeFeedback(id), setPractice);

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
  }
}
